(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cos24-novedades-native"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cos24-native-collection')) {
    customElements.define('cos24-native-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.root = this.closest('[data-c24-native]');
        this.status = this.querySelector('[data-c24-status]');
        this.retry = this.querySelector('[data-c24-retry]');
        this.retry.addEventListener('click', () => this.load(), {signal:this.events.signal});
        if (this.dataset.complete === 'true') this.finish();
        else this.load();
      }
      disconnectedCallback() {
        this.events?.abort(); this.request?.abort(); this.events = null; this.loading = false;
      }
      async page(number, signal, pageParam='page') {
        const url = new URL(this.dataset.source, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid collection');
        url.search = '';
        url.searchParams.set('section_id','cos24-novedades-data');
        url.searchParams.set('sort_by',this.dataset.sort || 'manual');
        url.searchParams.set(pageParam,String(number));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response = await fetch(url,{signal,credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection response');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const feed = doc.querySelector('[data-c24-feed]');
        if (!feed || feed.dataset.collection !== this.dataset.collection || Number(feed.dataset.page)!==number) throw new Error('Invalid feed');
        const pages = Number(feed.dataset.pages), total = Number(feed.dataset.total);
        if (!Number.isInteger(pages) || pages<0 || pages>100 || !Number.isInteger(total) || total<0 || total>25000) throw new Error('Pagination limit');
        const template = feed.querySelector(this.dataset.mode==='newest'?'[data-latest]':'[data-default]');
        if (!template) throw new Error('Missing cards');
        const cards = Array.from(template.content.querySelectorAll('[data-c24-product]'));
        if (total && !cards.length) throw new Error('Empty page');
        return {cards,pages,total,pageParam:feed.dataset.pageParam || 'page'};
      }
      select(cards) {
        return Array.from(new Map(cards.map(card=>[card.dataset.c24Product,card])).values())
          .sort((a,b)=>Number(b.dataset.c24Published)-Number(a.dataset.c24Published)||b.dataset.c24Product.localeCompare(a.dataset.c24Product))
          .slice(0,Number(this.dataset.limit));
      }
      async load() {
        if (this.loading || !this.events) return;
        this.loading=true;
        const request = this.request = new AbortController();
        const timer = setTimeout(()=>request.abort(),45000);
        this.retry.hidden=true;
        this.querySelector('[data-c24-fallback]').hidden=true;
        this.status.hidden=false;
        this.root.setAttribute('aria-busy','true');
        try {
          const first = await this.page(1,request.signal);
          let selected = first.cards.slice(0,Number(this.dataset.limit));
          if (this.dataset.mode==='newest') {
            selected = this.select(first.cards);
            let next=2;
            const worker=async()=>{
              while(next<=first.pages) {
                const result=await this.page(next++,request.signal,first.pageParam);
                if (result.pages!==first.pages || result.total!==first.total) throw new Error('Collection changed');
                selected=this.select(selected.concat(result.cards));
              }
            };
            await Promise.all([worker(),worker()]);
          }
          if (selected.length!==Math.min(first.total,Number(this.dataset.limit))) throw new Error('Incomplete list');
          let instance;
          for(let attempt=0;attempt<100;attempt++) {
            if (request.signal.aborted || !this.isConnected) throw new Error('Interrupted');
            instance=window.Shopify?.theme?.sections?.instances?.find(item=>item.container===this.root);
            if (instance) break;
            await new Promise(resolve=>setTimeout(resolve,100));
          }
          if (!instance || typeof instance.onUnload!=='function' || typeof instance.onLoad!=='function') throw new Error('Native theme not ready');
          instance.onUnload();
          const list=this.root.querySelector('.featured-collection__container > .carousel, .featured-collection__container > .grid');
          const slots=Array.from(list.querySelectorAll('[data-product-block]'));
          selected.forEach((card,index)=>{
            const slot=slots[index];
            const bundle=card.closest('[data-c24-native-package]');
            const layoutClasses=/^(one-|mobile--|grid-item--|carousel__item$|grid__item$)/;
            Array.from(card.classList).filter(name=>layoutClasses.test(name)).forEach(name=>card.classList.remove(name));
            if (slot) Array.from(slot.classList).filter(name=>layoutClasses.test(name)).forEach(name=>card.classList.add(name));
            if (Number(this.root.dataset.columns)===6) card.classList.add('one-sixth');
            if (this.root.classList.contains('featured-collection--carousel')) card.setAttribute('data-slide','');
            else card.removeAttribute('data-slide');
            const prefix=`${this.root.dataset.sectionId}-${index}`;
            (bundle || card).querySelectorAll('*').forEach(element=>{
              for(const attribute of Array.from(element.attributes)) {
                if (attribute.value.includes('cos24-novedades-data') && !['href','src','srcset','style'].includes(attribute.name)) element.setAttribute(attribute.name,attribute.value.replaceAll('cos24-novedades-data',prefix));
              }
            });
            card.id=card.id.replaceAll('cos24-novedades-data',prefix);
            const nodes=bundle?Array.from(bundle.childNodes):[card];
            if (slot) slot.replaceWith(...nodes); else list.append(...nodes);
          });
          slots.slice(selected.length).forEach(slot=>slot.remove());
          this.root.removeAttribute('data-c24-native-pending');
          this.dataset.complete='true';
          this.loadedAsync=true;
          instance.onLoad();
          this.finish();
          this.dispatchEvent(new CustomEvent('cos24:novedades:loaded',{bubbles:true}));
        } catch(error) {
          if (this.isConnected && this.request===request) {
            this.querySelector('[data-c24-message]').textContent=this.querySelector('[data-c24-error]').content.textContent;
            this.status.hidden=false; this.retry.hidden=false; this.querySelector('[data-c24-fallback]').hidden=false;
            this.querySelector('[data-c24-schema]')?.remove();
          }
        } finally {
          clearTimeout(timer); request.abort();
          if (this.request===request) { this.loading=false; this.root.removeAttribute('aria-busy'); }
        }
      }
      finish() {
        const cards=Array.from(this.root.querySelectorAll('[data-c24-product]'));
        const language=document.documentElement.lang || 'es';
        const formatter=new Intl.DateTimeFormat(language,{month:'short',timeZone:'UTC'});
        cards.forEach(card=>{
          const badge=card.querySelector('[data-c24-badge]');
          if (!badge) return;
          const age=Number(this.dataset.now)-Number(card.dataset.c24Published);
          badge.hidden=!(this.dataset.mode==='newest' && Number(card.dataset.c24Published)>0 && age>=0 && age<Number(this.dataset.days)*86400);
          const date=card.dataset.c24Date;
          if (date) {
            const month=formatter.format(new Date(`${date}T12:00:00Z`)).replace('.','').slice(0,3).toUpperCase();
            badge.querySelector('span').textContent=`${this.dataset.label} · ${month}-${date.slice(2,4)}`;
          }
        });
        this.status.hidden=true;
        if (!cards.length && this.loadedAsync) {
          this.status.hidden=false;
          this.querySelector('[data-c24-message]').textContent=this.querySelector('[data-c24-empty]').content.textContent;
        }
        let schema=this.querySelector('[data-c24-schema]');
        if (this.dataset.mode!=='newest' || this.dataset.schema!=='true' || !cards.length) { schema?.remove(); return; }
        const graph={'@context':'https://schema.org','@type':'ItemList','@id':this.dataset.schemaId,
          name:this.root.querySelector('.section__heading')?.textContent.trim() || '',
          description:this.root.querySelector('.featured-collection__top .section__text')?.textContent.trim() || '',
          numberOfItems:cards.length,itemListOrder:'https://schema.org/ItemListOrderDescending',
          itemListElement:cards.map((card,index)=>({'@type':'ListItem',position:index+1,name:card.querySelector('.product-grid-item__title__text')?.textContent.trim() || card.dataset.c24Name,url:new URL(card.dataset.c24Url,location.origin).href}))};
        if (!schema) { schema=document.createElement('script'); schema.type='application/ld+json'; schema.dataset.c24Schema=''; this.append(schema); }
        schema.textContent=JSON.stringify(graph).replace(/</g,'\\u003c');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
